// src/theme/my-preset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const AppPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f5f3ff',
            100: '#ede9fe',
            200: '#ddd6fe',
            300: '#c4b5fd',
            400: '#a78bfa',
            500: '#7c3aed',
            600: '#6d28d9',
            700: '#5b21b6',
            800: '#4c1d95',
            900: '#3b0764'
        },
    },
    components: {
        button: {
            colorScheme: {
                light: {
                    root: {
                        primary: {
                            background: '{primary.500}',
                            hoverBackground: '{primary.500}',
                            activeBackground: '{primary.700}',
                            color: '#ffffff',
                        },
                    },
                    outlined: {
                        primary: {
                            borderColor: '{primary.500}',
                            color: `{primary.500}`
                        }
                    }
                }
            }
        },
        select: {
            colorScheme: {
                light: {
                    option: {
                        focusColor: '{list.option.selected.focus.color}',
                        focusBackground: '{list.option.selected.focus.background}'
                    }
                }
            }
        }
    }
});

export default AppPreset;
